import { useApp } from '../context/AppContext';
import { translations } from '../i18n/translations';

export const useTranslation = () => {
  const { state } = useApp();
  const lang = state.language;
  
  const t = (key, vars) => {
    let str = translations[lang]?.[key] || translations['en']?.[key] || key;
    if (vars && typeof str === 'string') {
      Object.entries(vars).forEach(([k, v]) => {
        str = str.split(`{{${k}}}`).join(String(v));
      });
    }
    return str;
  };
  
  return { t, lang };
};
